import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedCompany: '',
  uploadedFile: '',
  uploadStatus: 'idle',
  errorMessage: '',
  uploadReport: null,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setSelectedCompany(state, action) {
      state.selectedCompany = action.payload;
    },
    setUploadedFile(state, action) {
      state.uploadedFile = action.payload;
    },
    setUploadStatus(state, action) {
      state.uploadStatus = action.payload;
    },
    setErrorMessage(state, action) {
      state.errorMessage = action.payload;
    },
    setUploadReport(state, action) {
      state.uploadReport = action.payload;
    },
    clearUploadReport(state) {
      state.uploadReport = null;
    },
    resetUploadForm(state) {
      state.selectedCompany = '';
      state.uploadedFile = '';
      state.uploadStatus = 'idle';
      state.errorMessage = '';
    },
  },
});

export const {
  setSelectedCompany,
  setUploadedFile,
  setUploadStatus,
  setErrorMessage,
  setUploadReport,
  clearUploadReport,
  resetUploadForm,
} = uploadSlice.actions;

export default uploadSlice.reducer;
